var map = {
	"./Anyswap.png": 757,
	"./Anyswap.svg": 758,
	"./Artwork.svg": 759,
	"./Artwork_gmx.svg": 760,
	"./Banxa.png": 761,
	"./DROP_DOWN.svg": 332,
	"./Hop.png": 762,
	"./Hop.svg": 763,
	"./Hop_dark.png": 764,
	"./Hop_dark.svg": 765,
	"./Synapse.png": 766,
	"./Synapse.svg": 767,
	"./arrow-left.svg": 343,
	"./background_mesh.png": 768,
	"./background_mesh_mobile.png": 344,
	"./binance.png": 769,
	"./bscscan.png": 770,
	"./btn_big_arbitrum.png": 771,
	"./btn_big_avalanche.png": 772,
	"./btn_big_bsc.png": 773,
	"./buy_gmx.svg": 774,
	"./buy_transfer_eth.svg": 775,
	"./chevron-down.svg": 345,
	"./close.svg": 338,
	"./coinbaseWallet.png": 346,
	"./coingecko.png": 776,
	"./copy.svg": 224,
	"./cross.svg": 777,
	"./discord.svg": 347,
	"./gitbook.svg": 348,
	"./github.svg": 349,
	"./glp_icon.svg": 778,
	"./graphite-01.png": 779,
	"./ic-communityproject.svg": 780,
	"./ic_arbitrum_16.svg": 220,
	"./ic_arbitrum_24.svg": 221,
	"./ic_arbitrum_96.svg": 781,
	"./ic_arbitrum_hover_16.svg": 782,
	"./ic_avalanche_16.svg": 219,
	"./ic_avalanche_24.svg": 222,
	"./ic_avalanche_96.svg": 783,
	"./ic_avax_24.svg": 456,
	"./ic_avax_30.svg": 784,
	"./ic_avax_40.svg": 438,
	"./ic_bal_24.svg": 457,
	"./ic_bal_40.svg": 439,
	"./ic_banxa.svg": 785,
	"./ic_binance_logo.svg": 786,
	"./ic_bsc.svg": 787,
	"./ic_bsc_96.svg": 788,
	"./ic_btc_24.svg": 458,
	"./ic_btc_40.svg": 440,
	"./ic_busd_24.svg": 459,
	"./ic_cash.png": 789,
	"./ic_cash.svg": 790,
	"./ic_coingecko_16.svg": 329,
	"./ic_coingecko_hover_16.svg": 791,
	"./ic_convert_down.svg": 336,
	"./ic_copy_16.svg": 340,
	"./ic_cost.svg": 792,
	"./ic_crv_24.svg": 460,
	"./ic_crv_40.svg": 441,
	"./ic_ctm_40.svg": 442,
	"./ic_dai_24.svg": 461,
	"./ic_dai_40.svg": 443,
	"./ic_degen.svg": 337,
	"./ic_discord.svg": 793,
	"./ic_eth_24.svg": 462,
	"./ic_eth_40.svg": 323,
	"./ic_frax_24.svg": 463,
	"./ic_frax_40.svg": 444,
	"./ic_fxs_24.svg": 464,
	"./ic_fxs_40.svg": 445,
	"./ic_github.svg": 794,
	"./ic_gmx_arbitrum.svg": 795,
	"./ic_gmx_avax.svg": 796,
	"./ic_hop.svg": 797,
	"./ic_info.svg": 798,
	"./ic_link_24.svg": 465,
	"./ic_link_40.svg": 446,
	"./ic_liquidity.svg": 799,
	"./ic_medium.svg": 800,
	"./ic_metamask_16.svg": 330,
	"./ic_metamask_hover_16.svg": 801,
	"./ic_mim_24.svg": 466,
	"./ic_mim_40.svg": 447,
	"./ic_mlp_24.svg": 223,
	"./ic_mlp_40.svg": 147,
	"./ic_mlp_custom.svg": 802,
	"./ic_multiswap.svg": 803,
	"./ic_myc.svg": 328,
	"./ic_myc_40.svg": 266,
	"./ic_myc_custom.svg": 804,
	"./ic_nav_close.svg": 350,
	"./ic_new_link_16.svg": 339,
	"./ic_olympus.svg": 805,
	"./ic_olympus_arbitrum.svg": 806,
	"./ic_ppusd_24.svg": 467,
	"./ic_ppusd_40.svg": 448,
	"./ic_selector_dropdowns.svg": 239,
	"./ic_settings_16.svg": 341,
	"./ic_sign in_16.svg": 807,
	"./ic_sign_out_16.svg": 342,
	"./ic_simpleswaps.svg": 808,
	"./ic_stats.svg": 809,
	"./ic_stats_big.svg": 810,
	"./ic_synapse.svg": 811,
	"./ic_tcr_24.svg": 468,
	"./ic_tcr_40.svg": 449,
	"./ic_telegram.svg": 812,
	"./ic_tether_24.svg": 469,
	"./ic_tokens.svg": 813,
	"./ic_totaluser.svg": 814,
	"./ic_trading.svg": 815,
	"./ic_transfer_avax.svg": 816,
	"./ic_twitter.svg": 817,
	"./ic_uni_24.svg": 470,
	"./ic_uni_40.svg": 450,
	"./ic_usdc.e_24.svg": 471,
	"./ic_usdc.e_40.svg": 451,
	"./ic_usdc_24.svg": 472,
	"./ic_usdc_40.svg": 452,
	"./ic_usdt_24.svg": 473,
	"./ic_usdt_40.svg": 453,
	"./ic_wallet_24.svg": 184,
	"./ic_wavax_24.svg": 474,
	"./ic_wavax_40.svg": 454,
	"./ic_weth_24.svg": 475,
	"./ic_weth_40.svg": 455,
	"./lg_arbitrum.svg": 818,
	"./logo_MYC.svg": 142,
	"./logo_MYC_small.svg": 287,
	"./logo_TRS.svg": 819,
	"./logo_TRS_small.svg": 820,
	"./long.svg": 333,
	"./metamask-text.svg": 821,
	"./metamask.png": 351,
	"./myc_pools.svg": 822,
	"./myc_pools_short.svg": 193,
	"./myc_pools_switch.svg": 823,
	"./myc_swaps.svg": 824,
	"./page-not-found.svg": 352,
	"./short.svg": 334,
	"./swap.svg": 335,
	"./trading.png": 825,
	"./twitter.svg": 353,
	"./wallet-connect-text.svg": 826,
	"./walletconnect-circle-blue.svg": 354,
	"./wave-01.png": 827,
	"./wave-02.png": 828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 262;